import setCssVar from './setCssVar';

const setStickyButtonHeightCssVar = height => {
  setCssVar('--sticky-pdp-button-height', height);
};

export default setStickyButtonHeightCssVar;
